import { Injectable } from "@angular/core";
import { ShowToastResult, ToastService } from "@siemens/ix-angular";

/** Used to define global toast config defaults */
@Injectable()
export class AppToastService extends ToastService {
  public override show(config: Parameters<ToastService["show"]>[0]): Promise<ShowToastResult> {
    if (config && config.autoCloseDelay === undefined) {
      config = Object.assign({}, config, { autoCloseDelay: 8000 });
    }
    return super.show(config);
  }
}
